import { CheckCircledIcon, ReloadIcon } from "@radix-ui/react-icons";
import { Button, Card, Container, Flex, Heading, Text } from "@radix-ui/themes";
import LoadingIndicator from "./shared/LoadingIndicator";

interface Props {
    userEmail?: string;
    onRetry?: () => void;
    /** Desktop app has redeemed the auth code (Realtime-observed). */
    connected?: boolean;
    showRetry?: boolean;
}

export default function DesktopRedirectingView({ userEmail, onRetry, connected = false, showRetry = false }: Props) {
    return (
        <Container size="1" p="4">
            <Card
                size="4"
                style={{
                    maxWidth: 500,
                    margin: "0 auto",
                    textAlign: "center",
                    padding: "40px 20px",
                }}
            >
                {connected ? (
                    <>
                        <div
                            style={{
                                marginBottom: 20,
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <CheckCircledIcon width="64" height="64" color="var(--accent-9)" />
                        </div>

                        <Heading
                            size="6"
                            mb="4"
                            style={{
                                color: "var(--accent-9)",
                            }}
                        >
                            Desktop app connected
                        </Heading>

                        <Text as="p" size="3" color="gray" mb="6">
                            Your Desktop Commander app has finished signing in.
                        </Text>

                        {userEmail && (
                            <Text
                                as="p"
                                size="4"
                                weight="bold"
                                mb="6"
                                style={{
                                    color: "white",
                                }}
                            >
                                {userEmail}
                            </Text>
                        )}

                        <Text as="p" size="2" color="gray">
                            You can safely close this window.
                        </Text>
                    </>
                ) : !showRetry ? (
                    <>
                        <div
                            style={{
                                marginBottom: 20,
                            }}
                        >
                            <LoadingIndicator text="" />
                        </div>

                        <Heading
                            size="6"
                            mb="4"
                            style={{
                                color: "var(--accent-9)",
                            }}
                        >
                            Authentication in progress
                        </Heading>

                        <Text as="p" size="3" color="gray" mb="6">
                            Please wait while Desktop Commander finishes signing you in...
                        </Text>

                        {userEmail && (
                            <Text as="p" size="2" color="gray" mb="2">
                                Signed in as:{" "}
                                <strong
                                    style={{
                                        color: "white",
                                    }}
                                >
                                    {userEmail}
                                </strong>
                            </Text>
                        )}

                        <Text as="p" size="2" color="gray" mt="6">
                            If you are not redirected automatically, please check your Desktop Commander app.
                        </Text>
                    </>
                ) : (
                    <>
                        <Heading
                            size="6"
                            mb="4"
                            style={{
                                color: "var(--accent-9)",
                            }}
                        >
                            Something went wrong
                        </Heading>

                        <Text as="p" size="3" color="gray" mb="6">
                            Desktop Commander is taking longer than expected to finish signing you in.
                        </Text>

                        {onRetry && (
                            <Flex direction="column" gap="2" mt="5" align="stretch">
                                <Button size="3" variant="solid" onClick={onRetry}>
                                    <ReloadIcon /> Retry
                                </Button>
                            </Flex>
                        )}
                    </>
                )}
            </Card>
        </Container>
    );
}
